/**
 * ContentGrid Component
 * Standardized grid layout for content cards
 */

import styled from 'styled-components';

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export default ContentGrid;
